import React from 'react'
import { Navigate } from 'react-router-dom'
import { Stack, Typography } from '@mui/material'
import { useNetworkScope } from '../../hooks/useNetworkScope'

// Where a brand client lands on '/' — their own brand's portal (TDC-1609).
//
// A client belongs to exactly one brand, so there is nothing to disambiguate:
// useNetworkScope resolves basePath from that membership.
export function PortalEntry() {
  const { basePath } = useNetworkScope()

  if (!basePath) {
    // No slug on the brand. That is an ops problem (a brand row that never got
    // one), not a bad URL, so say so rather than showing a 404 — the same
    // reasoning as the empty state in pages/rmn/RmnEntryRedirect.
    return (
      <Stack width={1} minHeight="50vh" alignItems="center" justifyContent="center" gap={1}>
        <Typography variant="h6" color="text.primary">
          No portal available
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Your brand doesn&apos;t have a portal address yet. Please contact The Desire
          Company and we&apos;ll get it set up.
        </Typography>
      </Stack>
    )
  }

  return <Navigate to={`${basePath}/dashboard`} replace />
}
